/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.redeemAmazonCatalogueItem.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class RedeemAmazonItemRequest(
    @SerialName("intent")
    val intent: String,

    /** A list of rewards to redeem. */
    @SerialName("catalog_items")
    val catalogItems: List<AmazonRedemptionModel>,

    @SerialName("trial_mode")
    val trialMode: Boolean,

    @SerialName("branch")
    val branch: AmazonRedemptionBranchModel,

    @SerialName("customer")
    val customer: AmazonRedemptionCustomerModel
)
